module.exports = __webpack_public_path__ + "img/link_logo6.293a8597.png";